<template>
  <div v-loading="loading" class="plan-table-container">
    <iframe id="warehousePlanOrder" ref="iframeRef" class="plan-table-iframe" :src="iframeSrc" frameborder="0"></iframe>
  </div>
</template>
<script>
// import {transferToken} from "@/api/user";
import env from "../../../../../env";

export default {
  name: 'IndexIframe',
  components: {
  },
  data() {
    return {
      iframeSrc:'',
      loading: true,
    }
  },
  computed:{

  },
  created(){
    this.init()
    this.getUrl()
  },
  destroyed() {
    this.removeListLoadStatus()
  },
  methods: {
    init(){
      this.$nextTick(()=>{
        this.$refs.iframeRef.addEventListener("load", this.addListLoadStatus);
      })
    },
    addListLoadStatus() {
      this.loadCompelete()
    },
    removeListLoadStatus() {
      this.$refs.iframeRef.removeEventListener(this.addListLoadStatus)
    },
    loadCompelete() {
      this.loading = false;
    },
    async getUrl() {
      const userInfo=this.$store.state.user
      const customers = userInfo?.customers || [{customerCode: userInfo?.customerCode,customerName:userInfo?.accountName}];
      // const data = {
      //   clientCode: 'otbwms_web', // 配置获取
      //   identifier: userInfo.mobile,
      //   unifyId: userInfo?.unifyId,
      //   userIdentity: 'TENANT', // 配置获取
      //   loginExt: {
      //     originalSystemCode: 'otms',
      //     systemCode: 'customer_account',
      //     securityKey:'ylz-security-pc'
      //   },
      // };
      // const res = await transferToken(data)
      this.iframeSrc = `${env.OTMS_ADMIN_URL}oms/warehousePlan?tab=WAIT_DEAL&clientCode=otbwms_web&systemCode=otms&userIdentity=TENANT&tenantId=${userInfo.tenantId}&tenantName=${userInfo.tenantName}&token=${userInfo.token}&source=customer_account&hiddenMenu=true&userId=${userInfo.userId}&customers=${JSON.stringify(customers)}&hideQuickBar=true&ignoreLogin=true`
    }
  }
}
</script>
<style lang="less" scoped>
  .plan-table-container {
    width: 100%;
    height: calc(100vh - 145px);
    .plan-table-iframe {
      width: 100%;
      height: 100%;
    }
  }
</style>
